import React, { useEffect, useState } from "react";
import { GridComponent, ColumnsDirective, ColumnDirective, Inject, Page } from "@syncfusion/ej2-react-grids";
import { IoMdDownload } from "react-icons/io";
import EmptyData from "../../../components/EmptyData";

export default function GridVehicleActivities({
    gridData,
    isLoading,
    handleDownload,
    pageSize,
    setPageSize
}) {
    const fields = [
        'reportId',
        'requestDate',
        'startDate',
        'endDate',
        'maxSpeed',
        'startProfessional',
        'endProfessional',
        'statusDescription',
        'excel'
    ];

    const columns = [
        'ID',
        'Data Solicitação',
        'Data Inicial',
        'Data Final',
        'Vel',
        'Hora Inicial',
        'Hora Final',
        'Status',
        'Excel'
    ];

    const [allData, setAllData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);

    const getPaginatedData = () => {
        const startIndex = (currentPage - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        return allData.slice(startIndex, endIndex);
    };

    const paginatedData = getPaginatedData();

    useEffect(() => {
        if (gridData && Array.isArray(gridData)) {
            setAllData(gridData);
            setCurrentPage(1);
        }
    }, [gridData]);
    
    const formatDateToDDMMYYYY = (dateString) => {
        if (!dateString) return "";

        const date = new Date(dateString);

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    };

    const handleActionTemplate = (field, item) => {
        if (field === "excel") {
            return (
                <button
                    className="btn btn-primary"
                    style={{ margin: 8 }}
                    onClick={() => handleDownload(item)}
                    disabled={isLoading}
                >
                    <IoMdDownload />
                </button>
            );
        } if (field === "requestDate" || field === "startDate" || field === "endDate") {
            return item[field] ? formatDateToDDMMYYYY(item[field]) : "";
        }
        return item[field];
    };

    const calculatePageSize = () => {
        const rowHeight = 45;
        const windowHeight = window.innerHeight * 0.2; // 70% da altura da tela
        const itemsPerPage = Math.max(Math.floor(windowHeight / rowHeight), 10);
        setPageSize(itemsPerPage);
    };

    useEffect(() => {
        calculatePageSize();
        window.addEventListener("resize", calculatePageSize);

        return () => window.removeEventListener("resize", calculatePageSize);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [setPageSize]);

    return (
        <div className="card">
            <div className="table-responsive text-nowrap">
                <GridComponent
                    dataSource={paginatedData}
                    allowPaging={true}
                    pageSettings={{ pageSize, currentPage }}
                    emptyRecordTemplate={() => <EmptyData />}
                >
                    <ColumnsDirective>
                        {fields.map((field, index) => (
                            <ColumnDirective
                                key={index}
                                field={field}
                                headerText={columns[index]}
                                width="150"
                                textAlign="Left"
                                template={(item) => handleActionTemplate(field, item)}
                            />
                        ))}
                    </ColumnsDirective>
                    <Inject services={[Page]} />
                </GridComponent>
            </div>
        </div>
    );
}
